import Loadable from '../../components/loadable';

const ContactRecipients = Loadable({
  loader: () => import('../../pages/contacts/recipients'),
  type: 'block',
});

angular.module('gym').value('ContactRecipients', ContactRecipients);

const EditContactRecipientModal = Loadable({
  loader: () => import('../../pages/contacts/recipients/edit_contact_recipient_modal'),
  type: 'modal',
});

angular.module('gym').value('EditContactRecipientModal', EditContactRecipientModal);
